<template>
    <!-- 图文内容可编辑区域[[ -->
    <div class="edit-content img-content">
        <!-- 交互说明
            活动广场进入才显示activity-title
            -->
        <div class="activity-title f-hide">参与活动：《王者荣耀》峡谷初夏 清新好礼</div>
        <game-list ref="gameList" @gameChange="choiceGame"></game-list>

        <div class="title">
            <input v-model.trim="params.articleTitle" type="text" class="title-textarea" rows="1" maxlength="30"
                placeholder="请输入标题内容（10~30个字以内）">
            <span class="wordsNum">{{titleLength}}/30</span>
            <!-- 7.5修改 -->
            <!-- 错误提示 -->
            <p class="error-prompt" v-show="tips.title">标题至少10个字符~</p>
        </div>
        <tgl-richeditor :id="richOptions.id" :buttons="richOptions.buttons" :height="richOptions.height" ref="richeditor">
        </tgl-richeditor>
        <div class="img-upload">
            <tgl-image-cloud-upload style="display: inline-block" btnId='pic1' :minWidth="640" :minHeight="360"
                :isCrop="true" :maxSize="6*1024*1024" ref="imgUpload" @completed="imageUploadCompleted"
                @deletePic="deletePic">
                <template #text>
                    <div class="upload-text">点击上传封面图片</div>
                </template>
            </tgl-image-cloud-upload>
            <div class="upload-tips">
                上传高清、无二维码、无黑边的封面图、将获得更多推荐机会
                <br>
                支持最小尺寸640*360，最大6MB，格式为jpg/png的图片
            </div>
            <!-- 7.5修改 -->
            <!-- 错误提示 -->
            <p class="error-prompt" v-show="tips.cover">未上传封面图片</p>
        </div>
        <!-- 7.11添加 -->
        <!-- 12dd{{userIdentityData.flowUser}} -->
        <div class="flow-reward" v-show="userIdentityData.flowUser.code">
            <i class="ico-writing" :class="params.isJoinFlow ? 'ico-checkbox-checked' : 'ico-checkbox'"
                @click="params.isJoinFlow == 0 ? params.isJoinFlow=1 : params.isJoinFlow=0"></i>
            <p class="flow-reward-text f-inlineblock-top" @click="params.isJoinFlow == 0 ? params.isJoinFlow=1 : params.isJoinFlow=0">参与流量奖励（每月参与流量奖励的内容上限{{userIdentityData.flowUser.remain}}篇，您当月已投稿参与流量奖励的内容量为<span>{{userIdentityData.flowUser.join}}</span>篇）</p>
        </div>
        <div class="declaration">
            <i class="ico-writing" :class="params.isOriginal ? 'ico-checkbox-checked' : 'ico-checkbox'"
                @click="params.isOriginal == 0 ? params.isOriginal=1 : params.isOriginal=0"></i>
            <!-- <i class="ico-writing ico-checkbox-checked f-hidden"></i> -->
            <div class="declaration-text" @click="params.isOriginal == 0 ? params.isOriginal=1 : params.isOriginal=0">声明原创（获得更高收益与曝光）</div>
            <i class="ico-writing ico-question"></i>
            <div class="g-tooltip declaration-tips">
                <div class="g-tooltip-arrows-down"></div>
                <div class="tooltip-content">
                    伪造原创声明，将损失您的信用分和收益哦
                </div>
            </div>
        </div>
        <content-preview ref="contentPreview"></content-preview>
    </div>
    <!-- 图文内容可编辑区域]] -->
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/contribute/contribute.scss';
#tgl-rich__editor {
    font-size: 14px;
    /deep/ .tig-editor-wrapper {
        border-bottom-color: #ebebeb;
    }
    /deep/ .editor-toolbar {
        border-bottom-color: #ebebeb;
    }
    /deep/ .tig-btn {
        display: inline-block;
        margin-right: 5px;
    }
    /deep/ input[type='submit'] {
        width: 72px;
        line-height: 25px;
        height: 25px;
        box-sizing: border-box;
    }
    /deep/ .controls {
        margin-bottom: 5px;
    }
    /deep/ #upload-image-pannel {
        .control-label {
            display: inline-block;
        }
        .controls {
            margin-left: 0;
            display: inline-block;
            margin-bottom: 15px;
        }
    }
}
</style>

<script>
import gameList from 'Components/v4/dropdown/gamelist_v4';
import contentPreview from 'Components/v4/pop/content_preview';
import {
    SaveArticle, SaveArticleDraft
} from 'Services/getData';

export default {
    data() {
        return {
            params: {
                id: '',             //	文章id	int	否	null	文章id
                draftId: '',        //	草稿id	int	否	null	草稿id
                gameId: '',         //	游戏id	int	是	null	游戏id
                articleTitle: '',   //	内容标题	string	是	null	内容标题
                articleContent: '', //	正文	string	是	null	文章正文
                tags: '',           //	标签	string	是	null	标签,逗号分割如："标签1,标签2"
                coverImgId: '',     //	封面图对应附件id	int	是	null	封面图对应附件表的id
                isOriginal: 0,  //	是否原创	int	否	0	内容原创申明，1：勾选原创 0：没有勾选
                isJoinFlow: 0,     //	是否参与流量奖励	int	否	0	0:不参与 1：参与
                mediaInfo: []      //	分发信息	string	是	null	格式：[{"accountId":123,"title":"xx","cover":"https://1.jpg"}, ..],若无智能编目title:"",cover:""
            },
            showAll: false,
            tips: {
                title: false,
                articleContent: false,
                cover: false
            },
            userIdentityData: {
                tglVerify: {},
                flowUser: {}
            },
            coverUrl: '',
            open: true,
            edit_times: 0,
            total_sec: Date.now(),
            richOptions: {
                id: 'rich',
                buttons: [
                    'h1', 'bold', 'italic', 'underline', 'blockquote', 'hr', '|',
                    'font', 'size', 'color', '|',
                    'insertorderedlist', 'insertunorderedlist', 'justify', '|',
                    'link', 'table', 'image', 'video', '|',
                    'removeFormat', 'undo', 'redo', '|',
                    'fullscreen'
                ],
                height: 320
            }
        }
    },
    computed: {
        titleLength() {
            return this.params.articleTitle.length;
        }
    },
    components: {
        gameList,
        contentPreview
    },
    methods: {
        resetPage() {
            this.params.id = '';
            this.params.draftId = '';
            this.params.gameId = '';
            this.params.articleTitle = '';
            this.params.articleContent = '';
            this.params.tags = '';
            this.params.coverImgId = '';
            this.params.isOriginal = 0;
            this.params.isJoinFlow = 0;
            this.params.mediaInfo = [];
            this.$refs.richeditor.setHtml('')
            this.$refs.gameList.deleteGame();
            this.$refs.imgUpload.deletePic();
            this.deletePic();
        },
        getAuthInfo(selectMediaList, autoAuth) {
            // this.$emit();
            // this.$parent.selectMediaList
            if (!autoAuth) {
                this.$parent.selectMediaList.forEach((v, k) => {
                    v.title = this.params.articleTitle;
                    v.cover = this.coverUrl;
                    v.summary = ''
                    // console.log(this.params.mediaInfo)
                    // let mediaInfo = {};
                    // // debugger
                    // mediaInfo.accountId = v.curAccount.id;
                    // if(autoAuth){
                    //     mediaInfo.title = '';
                    //     mediaInfo.cover = '';
                    // }else{
                    //     mediaInfo.title = v.title;
                    //     mediaInfo.cover = v.cover;
                    // }
                    // this.params.mediaInfo.push(mediaInfo);
                })
            }
        },
        getDraft(data, auth) {
            this.params.draftId = data.id;
            this.params.gameId = data.content.gameId;
            if (data.content.gameId) {
                this.$refs.gameList.syncGameInfoWithId(data.content.gameId);
            }
            this.params.articleTitle = data.content.articleTitle;
            this.$refs.richeditor.setHtml(data.content.articleContent)
            this.params.isJoinFlow = data.content.ugcProfitCheck;
            if (data.content.coverUrl) {
                this.params.coverImgId = data.content.coverImgId;
                this.$refs.imgUpload.uploadStatus = 3;
                this.$refs.imgUpload.setPic(data.content.coverUrl);
            }
            this.params.isOriginal = data.content.isOriginal;
            this.coverUrl = data.content.coverUrl;
        },
        cloneObj(obj) {
            //1 
            let newJsonObj = {};
            let items;

            newJsonObj = JSON.parse(JSON.stringify(obj));
            //2 
            for (items in obj) { if (typeof obj[items] == "function" || typeof obj[items] == "undefined" || obj[items] instanceof RegExp) { newJsonObj[items] = obj[items]; } }
            //3
            var newObj = new obj.constructor; for (items in newJsonObj) { newObj[items] = newJsonObj[items] }
            return newObj;
        },
        showPreview() {
            let data = this.cloneObj(this.params);
            data.creator = this.$store.state.realUserInfo.userName;
            data.created = `${new Date().toLocaleDateString()} ${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`;
            data.summary = this.params.articleContent;
            this.paramHasSet();
            data.articleContent = this.params.articleContent;
            data.articleType = 0;
            this.$refs.contentPreview.contributeInfo(data);
        },
        choiceGame(game) {
            // console.log(game)
            if (game) {
                this.params.gameId = game.id;
            } else {
                this.params.gameId = '';
            }
        },
        imageUploadCompleted(data) {
            this.params.coverImgId = data.id;
            this.coverUrl = data.url;
        },
        deletePic() {
            this.params.coverImgId = '';
            this.coverUrl = '';
        },
        getParams(selectMediaList, autoAuth) {
            this.params.mediaInfo = [];
            selectMediaList.forEach((v, k) => {
                console.log(this.params.mediaInfo)
                let mediaInfo = {};
                // debugger
                mediaInfo.accountId = v.curAccount.id;
                if (autoAuth) {
                    mediaInfo.title = '';
                    mediaInfo.cover = '';
                    mediaInfo.summary = '';
                } else {
                    mediaInfo.title = v.title;
                    mediaInfo.cover = v.cover;
                    mediaInfo.summary = v.summary;
                }
                this.params.mediaInfo.push(mediaInfo);
            })
            this.params.mediaInfo = JSON.stringify(this.params.mediaInfo);
        },
        paramHasSet() {
            this.params.articleContent = this.$refs.richeditor.getHtml();
            return this.params;
        },
        async saveDraft(selectMediaList, autoAuth) {
            this.getParams(selectMediaList, autoAuth);
            this.paramHasSet();
            if (this.open) {
                this.open = false;
                let res = await SaveArticleDraft(this.params);
                this.open = true;
                if (res.data.code == 0) {
                    this.params.draftId = res.data.data.draftId;
                    this.$alert('保存成功');
                }
            }
        },
        async publish(selectMediaList, autoAuth) {
            this.edit_times++;
            this.paramHasSet();

            this.getParams(selectMediaList, autoAuth);

            if (!this.params.gameId) {
                this.$alert("请选择游戏");
                return false;
            }
            this.params.articleTitle = this.params.articleTitle.replace(/\s/g, '');
            if (!this.params.articleTitle || this.titleLength < 10) {
                this.tips.title = true;
                this.$alert('标题至少10个字符~')
                return false;
            }
            if (!this.params.articleContent) {
                this.$alert("正文不能为空");
                return false;
            }
            if (!this.params.coverImgId) {
                this.tips.cover = true;
                this.$alert("未上传封面图片");
                return false;
            }
            // if(this.params.mediaInfo.length<=2){
            //     this.$alert("请选择渠道");
            //     return false;
            // }
            if (this.open) {
                let reqStartTime = Date.now();
                this.open = false;
                let res = await SaveArticle(this.$qs.stringify(this.params));
                this.open = true;
                this.$common.reportContribute(
                    res.data.code == 0 ? 1 : 0,
                    res.data.info,
                    this.edit_times,
                    'ugc',
                    reqStartTime,
                    this.total_sec,
                );
                if (res.data.code == 0) {
                    this.params.id = res.data.data.id;
                    this.$alert('发布成功', '操作', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$router.push({
                                name: 'v4-manage-content'
                            })
                        }
                    });
                }
            }

        }

    },
    watch: {
        // "params":{
        //     handler(curVal,oldVal){
        //         this.$emit('formParamChange');
        //     },
        //     deep:true
        // },
        "params.articleTitle": function () {
            this.tips.title = false;
        },
        // "params.articleContent" : function(){
        //     this.tips.game = false;
        // },
        "params.coverImgId": function () {
            this.tips.cover = false;
        }
    },
    directives: {
        focus: {
            update: function (el, {
                value
            }) {
                if (value) {
                    el.focus()
                }
            }
        }
    }
}
</script>